import { startLoading } from "../../redux/reducers/loadingSlice";
import http from "./http";

export const makePaymentForOrder = async (values) => {
    // let accessToken = localStorage.getItem("accessToken");
    let url = `/payment/payment-request`
    try {
        const previousData = await http.get(
            `/order/get-intiated-payment/${values.order_id}`
        )
        if (previousData?.result?.data?.paymentLink) {
            window.location.href = `${previousData?.result?.data?.paymentLink}`
            return previousData;
        }
        else {
            const response = await http.post(
                url,
                values
            );
            window.location.href = `${response.result.paymentLink}`
            return response;
        }
    } catch (error) {
        return error.response.data;
    }
}